import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";
import Modal from "react-modal";
import moment from "moment";

function FarmerSurveyTemplateForm(props) {
  const [templateName, setTemplateName] = useState("");

  const [FarmerSurveyTemplateData, setFarmerSurveyTemplateData] = useState([]);

  const { sendRequest: getFarmerSurveyTemplateData } = useHttp();
  const { sendRequest: postFarmerSurveyTemplateDetails } = useHttp();
  const frmRef = useRef({});

  const FillDetail = () => {
    getFarmerSurveyTemplateData(
      {
        url: `/api/farmerSurveyTemplate/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setFarmerSurveyTemplateData(res);
        }
      },
      (error) => {
        console.log("Error", error);
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getFarmerSurveyTemplateData]);

  const [itemList, setItemList] = useState([]);

  const submitHandler = (e) => {
    e.preventDefault();
    if (!props.update) {
      const isExistingtemplate = FarmerSurveyTemplateData.some(
        (FarmerSurveyTemplate) => FarmerSurveyTemplate.templateName === templateName
      );

      if (isExistingtemplate) {
        toast.error("Template name already exists");
        return;
      }
    }

    const surveyQuestionList = questions.map((q) => ({
      FarmerSurveyTemplateQuestionId: q.id,
      surveyQuestion: q.question,
      questionType: q.type,
      itemList: itemListMap[q.id] || [], 
    }));

    const data = {
      templateName: templateName.trim(),
      templateDate: moment(selectedDate).format("DD/MM/YYYY"),
      status: 1,
      orgId: parseInt(localStorage.getItem("orgId")),
      createdBy: parseInt(localStorage.getItem("id")),
      serviceId: props.sId,
      surveyQuestionList,
    };
    console.log(data)

    if (props.update) {
      data["farmerSurveyTemplateId"] = props.update.farmerSurveyTemplateId;
    }

    postFarmerSurveyTemplateDetails(
      {
        url: "/api/farmerSurveyTemplate/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (res) => {
        toast.success(
          `Farmer Survey Template Details ${props.update ? "Updated" : "Added"}`
        );
        props.addForm(false);
      },
      (error) => {
        toast.error(error || "Something went wrong");
        console.log(error);
      }
    );
  };

  const { sendRequest: getFarmerSurveyTemplate } = useHttp();


  useEffect(() => {
    if (props.update) {
      const Id = props.update.farmerSurveyTemplateId;

      getFarmerSurveyTemplate(
        {
          url: `/api/farmerSurveyTemplate/?orgId=${localStorage.getItem(
            "orgId"
          )}&farmerSurveyTemplateId=${Id}`,
        },
        (res) => {
          console.log("res:", res);

          const transformedData = res.surveyQuestionList&&res.surveyQuestionList.map((item) => ({
            ...item,
            id: item.farmerSurveyTemplateQuestionId || 0,
            type: item.questionType || "",
            question:item.surveyQuestion|| "",
            detail:item.itemList||[],
          }));

          const transformedItemListMap = res.surveyQuestionList?.reduce(
            (map, item) => {
              map[item.farmerSurveyTemplateQuestionId || item.id] = item.itemList || [];
              return map;
            },
            {}
          );

          setQuestions(transformedData || []);
          setItemListMap(transformedItemListMap || {});
      
        },
        (error) => {
          console.log("Error", error);
        }
      );
      setTemplateName(props.update.templateName);
    }
  }, [props.update]);

  const [questions, setQuestions] = useState([
    { id: 1, surveyQuestion: "", type: "List", itemList: ""},
  ]);

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 30);

  const templateDate = d.toISOString().slice(0, 10);

  const [selectedDate, setSelectedDate] = useState(templateDate);

  const handleDateChange = (e) => {
  
    setSelectedDate(e.target.value);
  };



  const handleAddQuestion = (e) => {
    setQuestions([
      ...questions,
      { id: questions.length + 1, question: "", type: "List" },
    ]);
  };

  const handleQuestionChange = (id, value) => {
    setQuestions(
      questions.map((q) => (q.id === id ? { ...q, question: value } : q))
    );
  };

  const handleTypeChange = (id, value) => {
    setQuestions(
      questions.map((q) => (q.id === id ? { ...q, type: value } : q))
    );
  };

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      top: 50,
    },
    content: {
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "400px",
      height: "80%",
      minHeight: "auto",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  const [isOpenSingle, setIsOpenSingle] = useState(false);
  const [isOpenMultiple, setisOpenMultiple] = useState(false);

  const closeType = () => {
    setIsOpenSingle(false);
    setisOpenMultiple(false);
  };

  const [itemListMap, setItemListMap] = useState({});
  const [currentQuestionId, setCurrentQuestionId] = useState(null);
  const handleDelete = (questionId, index) => {
    setItemListMap((prevMap) => {
      const updatedList = prevMap[questionId].filter((_, i) => i !== index);
      return {
        ...prevMap,
        [questionId]: updatedList,
      };
    });
  };

  const handleDelete1 = (index) => {
    setQuestions((prevQuestions) => prevQuestions.filter((_, i) => i !== index));
    setItemListMap((prevMap) => {
      const updatedMap = { ...prevMap };
      delete updatedMap[questions[index].id];
      return updatedMap;
    });
  };

  const openType = (questionId) => {
    setCurrentQuestionId(questionId);
    setIsOpenSingle(true);
  };

  const addItemToList = (e, questionId) => {
    e.preventDefault();

    const newItem = frmRef.current["itemName"]
      ? frmRef.current["itemName"].value
      : "";

    if (!newItem) return;

    setItemListMap((prevMap) => {
      const updatedList = prevMap[questionId] || [];

      if (!updatedList.includes(newItem)) {
        return {
          ...prevMap,
          [questionId]: [...updatedList, newItem],
        };
      } else {
        toast.error("Item already exists in the list");
        return prevMap;
      }
    });

    frmRef.current["itemName"].value = "";
  };

  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">&nbsp;
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Farmer Survey Template</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Date</label>
                        <input
                          type="date"
                          id="date"
                          name="date"
                          max={currentDate}
                          value={selectedDate}
                          onChange={handleDateChange}
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Template Name</label>
                        <input
                          type="text"
                          id="templateName"
                          required
                          className="form-control"
                          value={templateName}
                          onChange={(e) => setTemplateName(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>

                  <div className=" font-sans">
                    <h5 className="text-lg font-semibold">
                      Survey Question List :
                    </h5>
                    <table className="table table-bordered text-center">
                      <thead>
                        <tr>
                          <th className="p-2 border border-gray-300 text-center">
                            Sr. No
                          </th>
                          <th className="p-2 border border-gray-300 text-center">
                            Survey Questions
                          </th>
                          <th className="p-2 border border-gray-300 text-center">
                            Question Type
                          </th>
                          <th className="p-2 border border-gray-300 text-center">
                            Detail List
                          </th>
                          <th className="p-2 border border-gray-300 text-center">
                            Delete
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {questions&&questions.map((q, index) => (
                          <tr key={q.id}>
                            <td className="form-group text-center">
                              {index + 1}
                            </td>
                            <td className="form-group">
                              <input
                                type="text"
                                id={`question-${q.id}`}
                                required
                                className="form-control"
                                value={q.question}
                                onChange={(e) =>
                                  handleQuestionChange(q.id, e.target.value)
                                }
                              />
                            </td>
                            <td className="form-group">
                              <select
                                id={`questionType-${q.id}`}
                                className="form-control"
                                required
                                value={q.type}
                                onChange={(e) =>
                                  handleTypeChange(q.id, e.target.value)
                                }
                              >
                                <option value="Input Text">Input Text</option>
                                <option value="Input Numeric">Input Numeric</option>
                                <option value="Input Phone">Input Phone</option>
                                <option value="Single Choice">
                                  Single Choice
                                </option>
                                <option value="Multiple Choice">
                                  Multiple Choice
                                </option>
                              </select>
                            </td>
                            <td className="form-group">
                              {q.type === "Single Choice" ||
                              q.type === "Multiple Choice" ? (
                                <button
                                  type="button"
                                  value={q.detail}
                                  className="btn btn-primary"
                                  onClick={() => openType(q.id, q.type)}
                                >
                                  Add Details
                                </button>
                              ) : (
                                <button
                                  type="button"
                                  className="btn btn-primary"
                                  disabled
                                >
                                  Add Details
                                </button>
                              )}
                            </td>
                            <td>
                              <button
                                type="button"
                                className="btn"
                                onClick={() =>
                                  handleDelete1(index)
                                }
                              >
                                <i className="fas fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>

                    <div>
                      <button
                        type="button"
                        className="btn btn-primary float-right"
                        onClick={handleAddQuestion}
                      >
                        <i className="fas fa-plus"></i>
                      </button>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-1">
                      <button className="btn btn-primary my-2" type="submit">
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
      <Modal
        isOpen={isOpenSingle}
        style={customModalStyles}
        contentLabel="Details Modal"
      >
        <h3 className="card-title">Details</h3>
        <div className="card-tools text-right">
          <button
            type="button"
            className="btn btn-tool"
            data-card-widget="remove"
            onClick={() => setIsOpenSingle(false)}
          >
            <i className="fas fa-times" />
          </button>
          <hr />
        </div>
        <form onSubmit={(e) => addItemToList(e, currentQuestionId)}>
          <div className="row">
            <div className="form-group">
              <input
                type="text"
                id="itemName"
                required
                ref={(el) => (frmRef.current["itemName"] = el)}
                className="form-control"
              />
            </div>
          </div>
          <button className="btn btn-primary" type="submit">
            Add
          </button>
        </form>
        <table className="table table-bordered text-center">
          <thead>
            <tr>
              <th>Sr.No</th>
              <th>Item Name</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            {(itemListMap[currentQuestionId] || []).map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{item}</td>
                <td>
                  <button
                    type="button"
                    className="btn"
                    onClick={() => handleDelete(currentQuestionId, index)}
                  >
                    <i className="fas fa-trash"></i>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Modal>
    </>
  );
}

export default FarmerSurveyTemplateForm;  